import {
  convertDotcmsBoolean,
  convertDotcmsResponseToRecord,
  convertDotcmsString,
} from './converters-from-dotcms';
import type { IBaseObjectData } from './dotcms-base-object';
import type { IGqlHelper } from './gql-helper';

export type ICategoryData = IBaseObjectData & {
  name: string;
  key: string;
  active: boolean;
};

export const CategoryGqlHelper: IGqlHelper<ICategoryData> = {
  contentTypeName: null,
  gqlFieldsQuery: `
    name
    key
    active
  `,
  processGqlData: (gqlResponse: unknown) => {
    if (!gqlResponse) {
      return undefined;
    }

    const { name, key, active } = convertDotcmsResponseToRecord(gqlResponse);

    return {
      name: convertDotcmsString(name) ?? '',
      key: convertDotcmsString(key) ?? '',
      active: convertDotcmsBoolean(active) ?? false,
    };
  },
};

export const getActiveCategories = (
  cmsResponse: ReadonlyArray<Omit<ICategoryData, 'identifier' | 'contentType'>>,
): string[] =>
  cmsResponse.filter(({ active }) => active).map(({ name }) => name);
